import AppRouter from "./router/Router";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { LanguageProvider } from './functions/setGetLanguage'; // language
import { UserDataProvider } from './functions/updateUserData';
import { SettingsProvider } from './functions/updateSettings';
function App() {
  return (
    <UserDataProvider>
      <LanguageProvider>
        <SettingsProvider>
          {/* <Provider store={store}> */}
            <ThemeProvider theme={theme}>
              <AppRouter />
            </ThemeProvider>
          {/* </Provider> */}
        </SettingsProvider>
      </LanguageProvider>
    </UserDataProvider>
  );
}

export default App;
